import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { cn } from '../../lib/cn';
import { TONE_SOFT, TONE_TEXT, type Tone } from '../../lib/tone';
import { Icon, type LucideIcon } from '../ui/icon';

export interface CalloutProps {
  tone?: Tone;
  icon?: LucideIcon;
  title: ReactNode;
  children?: ReactNode;
  /** Mit Tonfläche, wenn er sich vom Inhalt abheben muss. */
  boxed?: boolean;
  className?: string;
}

/** Ein Hinweis über dem Inhalt. Höchstens einer pro Ansicht, kein farbiger Balken. */
export function Callout({ tone = 'highlight', icon = Info, title, children, boxed, className }: CalloutProps) {
  return (
    <div
      role={tone === 'danger' || tone === 'warning' ? 'alert' : 'note'}
      className={cn('flex flex-col gap-1', TONE_TEXT[tone], boxed && cn('rounded-lg px-4 py-3', TONE_SOFT[tone]), className)}
    >
      <div className="flex items-center gap-2">
        <Icon icon={icon} />
        <span className="font-medium">{title}</span>
      </div>
      {children && <div className={boxed ? 'text-foreground' : 'text-muted-foreground'}>{children}</div>}
    </div>
  );
}
